/* AFS B2B — saved lists page (PB-13/14). Renders lists and list detail from the
   lists store (b2b-lists.js). Personal/device lists are theme-complete; company/
   department/location shared lists require the account platform (see gap report). */
(function () {
  'use strict';

  var app = document.getElementById('SavedListsApp');
  if (!app || !window.AFSB2B) return;

  var Lists = window.AFSB2B.Lists;
  var Quote = window.AFSB2B.Quote;
  var cfg = window.AFSConfig || { routes: {} };
  var listView = app.querySelector('[data-lists-view]');
  var detailView = app.querySelector('[data-list-detail]');
  var emptyEl = app.querySelector('[data-lists-empty]');

  function activeId() {
    return new URLSearchParams(window.location.search).get('list');
  }

  function money(cents) {
    if (cents == null) return '';
    var fmt = cfg.moneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2)).replace(/<[^>]+>/g, '');
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderIndex() {
    var lists = Lists.all();
    var ids = Object.keys(lists);
    detailView.hidden = true;
    listView.hidden = false;
    if (!ids.length) { emptyEl.hidden = false; listView.querySelector('[data-lists-grid]').innerHTML = ''; return; }
    emptyEl.hidden = true;
    var html = '';
    ids.forEach(function (id) {
      var l = lists[id];
      html += '<article class="card">' +
        '<h3 class="card__title"><a href="?list=' + encodeURIComponent(id) + '">' + escapeHtml(l.name) + '</a></h3>' +
        '<p class="card__desc num">' + l.items.length + ' items · saved on this device</p>' +
        '<div class="product-card__secondary">' +
          '<button type="button" data-list-cart="' + id + '">Add all to cart</button>' +
          '<button type="button" data-list-quote="' + id + '">Add to quote</button>' +
          '<button type="button" data-list-delete="' + id + '">Delete</button>' +
        '</div></article>';
    });
    listView.querySelector('[data-lists-grid]').innerHTML = html;
  }

  function renderDetail(id) {
    var lists = Lists.all();
    var l = lists[id];
    if (!l) { window.location.search = ''; return; }
    listView.hidden = true;
    detailView.hidden = false;
    var html = '<div class="b2b-tool__head"><h1>' + escapeHtml(l.name) + '</h1>' +
      '<a href="?" class="btn btn--quiet btn--sm">← All lists</a>' +
      '<button type="button" class="btn btn--secondary btn--sm" data-list-cart="' + id + '">Add all to cart</button>' +
      '<button type="button" class="btn btn--teal btn--sm" data-list-quote="' + id + '">Request quote</button></div>';
    html += '<p class="text-muted mb-3">' + (app.dataset.localNote || '') + '</p>';
    if (!l.items.length) {
      html += '<div class="b2b-empty"><p>This list has no items yet. Add products from any product page.</p></div>';
    } else {
      html += '<div class="table-wrap panel" style="padding:0;"><table class="data-table"><thead><tr>' +
        '<th scope="col">Item</th><th scope="col">SKU</th><th scope="col" class="num">Preferred qty</th><th scope="col"></th>' +
        '</tr></thead><tbody>';
      l.items.forEach(function (i) {
        html += '<tr>' +
          '<td><a href="' + escapeHtml(i.url || '#') + '">' + escapeHtml(i.title) + '</a></td>' +
          '<td class="sku">' + escapeHtml(i.sku) + '</td>' +
          '<td class="num">' + (i.qty || 1) + '</td>' +
          '<td><button type="button" class="text-link" data-item-remove="' + escapeHtml(i.variantId) + '">Remove</button></td>' +
          '</tr>';
      });
      html += '</tbody></table></div>';
    }
    detailView.innerHTML = html;
    detailView.dataset.currentId = id;
  }

  function addListToCart(id) {
    var l = Lists.all()[id];
    if (!l || !l.items.length) return;
    var items = l.items.map(function (i) { return { id: i.variantId, quantity: i.qty || 1 }; });
    window.AFSCart.add(items)
      .then(function () { window.AFSToast('List added to cart', { tone: 'success', linkHref: cfg.routes.cart, linkText: 'View cart' }); })
      .catch(function () { window.AFSToast('Some items are no longer available. Review the list.', { tone: 'error' }); });
  }

  function addListToQuote(id) {
    var l = Lists.all()[id];
    if (!l) return;
    l.items.forEach(function (i) { Quote.add(i, i.qty || 1); });
    window.AFSToast('List added to quote', { tone: 'success', linkHref: cfg.pages.quote, linkText: 'View quote list' });
  }

  app.addEventListener('click', function (e) {
    var t = e.target;
    var cart = t.closest('[data-list-cart]'); if (cart) return addListToCart(cart.getAttribute('data-list-cart'));
    var quote = t.closest('[data-list-quote]'); if (quote) return addListToQuote(quote.getAttribute('data-list-quote'));
    var del = t.closest('[data-list-delete]');
    if (del) { if (window.confirm('Delete this list?')) Lists.remove(del.getAttribute('data-list-delete')); return; }
    var itemRemove = t.closest('[data-item-remove]');
    if (itemRemove) { Lists.removeItem(detailView.dataset.currentId, itemRemove.getAttribute('data-item-remove')); return; }
    var create = t.closest('[data-list-create]');
    if (create) {
      var name = window.prompt('Name your list (e.g. Monthly Restroom Supplies):');
      if (name) Lists.create(name.trim());
    }
  });

  function route() {
    var id = activeId();
    if (id) renderDetail(id); else renderIndex();
  }

  document.addEventListener('afs:lists-updated', route);
  route();
})();
